    // import logo from './logo.svg';
import '../App.css';
import '../lib/animate/animate.min.css';
import '../lib/lightbox/css/lightbox.min.css';
import '../lib/owlcarousel/assets/owl.carousel.min.css';
import '../css/bootstrap.min.css';
import '../css/style.css';



// src/App.js
import React, {useEffect, useState} from 'react';

import DisplayTable from "../components/tableDisplay";

import NAV from "../pages/nav";

import Carousel from "../pages/carousel";

import TopMoversHeatmap from "../components/movers";
import TrendingNewsScroller from "../components/newsscroll";
import PriceScroller from "../components/pricescroll_ver_2";
import IntradayHeatmap from "../components/stocks/intraday_heatmap";
import IntradayBubbleMap from "../components/stocks/intraday_pv";
import HighLowVolatilityChart from "../components/stocks/intraday_vol";
import VolumeSurgeTable from "../components/stocks/intraday_vol_surge";
import MomentumVsVolChart from "../components/stocks/intraday_vol_mom";

import StockHero from "../components/stocks/StockHero";
import MarketPulse from "../components/stocks/MarketPulse";
import AnalyticsCard from "../components/stocks/AnalyticsCard";

function StockHome() {
  const [movers, setMovers] = useState(null);

  // useEffect(() =>
  //     // Fetch the stock data from an API
  //     {   console.log('STOCK PAGE 1');
  //         fetchMarketMovers()
  //     .then(data => {
  //         const movers = JSON.parse(data)
  //         setMovers(movers);
  //         console.log('Movers',movers);
  //     })
  //     },[])

  return (
      // <div className="
      //   min-h-screen
      //   bg-slate-300
      //   ">
<div className="min-h-screen bg-slate-100">

    {/* NAV + HERO = ONE CONTINUOUS BLOCK */}

    <section
        className="
            bg-gradient-to-br
            from-slate-900
            via-slate-800
            to-slate-900
        "
    >
        <div className="pt-[100px]">

        <NAV activetag="stock" />

        <StockHero />
        </div>
    </section>
    {/* TICKERS */}

    <div className="bg-slate-950">
        <PriceScroller />
    </div>

        <div className="
            bg-slate-100
            py-8
        ">

            <div className="
                max-w-7xl
                mx-auto
                px-6
                py-8
            ">

            <MarketPulse />

            </div>

        </div>

            {/*<!-- Header End -->*/}


        <section className="
                    bg-slate-200
            text-3xl
            font-bold
            text-slate-900
        ">

            <div className="
                max-w-7xl
                mx-auto
                px-6
                py-10
            ">

                <h2 className="
                    text-3xl
                    font-bold
                    mb-8
                    text-slate-500
                ">
                    Market Movers
                </h2>

                <div className="
                    grid
                    lg:grid-cols-2
                    gap-6
                ">

                    <AnalyticsCard
                        title="Nifty 100 Heatmap"
                        subtitle="Today's winners and losers"
                    >

                        <TopMoversHeatmap
                            symbol="NIFTY 100"
                        />

                    </AnalyticsCard>

                    <AnalyticsCard
                        title="Sector Rotation"
                        subtitle="Sector leadership analysis"
                    >

                        <TopMoversHeatmap
                            symbol="sectors"
                        />

                    </AnalyticsCard>

                </div>

            </div>

        </section>

        <section className="

            font-bold
            text-slate-900
            ">

                <div className="
                    max-w-7xl
                    mx-auto
                    px-6
                    py-10
                ">

                    <h2 className="
                        text-3xl
                        font-bold
                        mb-8
                    text-slate-500
                    ">
                        Intraday Opportunities
                    </h2>

                    <div className="
                        grid
                        lg:grid-cols-2
                        gap-6
                    ">

                        <AnalyticsCard
                            title="Intraday Heatmap"
                        >
                            <IntradayHeatmap />
                        </AnalyticsCard>

                        <AnalyticsCard
                            title="Volume Surge Scanner"
                        >
                            <VolumeSurgeTable />
                        </AnalyticsCard>

                        <AnalyticsCard
                            title="Price Volume Map"
                        >
                            <IntradayBubbleMap />
                        </AnalyticsCard>

                        <AnalyticsCard
                            title="Volatility Leaders"
                        >
                            <HighLowVolatilityChart />
                        </AnalyticsCard>

                    </div>

                    <div className="mt-6">

                        <AnalyticsCard
                            title="Momentum vs Volatility"
                        >
                            <MomentumVsVolChart />
                        </AnalyticsCard>

                    </div>

                </div>

        </section>

        <section className="
                    bg-slate-200
            font-bold
            text-slate-900
        ">

            <div className="
                max-w-7xl
                mx-auto
                px-6
                py-10
            ">

                <h2 className="
                    text-3xl
                    font-bold
                    mb-8
                    text-slate-500
                ">
                    Technical Health
                </h2>

                {/*<AnalyticsCard*/}
                {/*    title="Nifty 50 Technical Snapshot"*/}
                {/*    subtitle="Trend, RSI, Momentum, Breakout Status"*/}
                {/*>*/}

                    <DisplayTable
                        table="ta"
                        symbol="nifty_50"
                    />

                {/*</AnalyticsCard>*/}

            </div>

        </section>

        {/*<!-- Tech Analysis Start -->*/}
        {/*<!-- Tech Analysis End -->*/}

        {/*}<!-- Back to Top -->*/}
        <a href="#" class="btn btn-primary btn-lg-square rounded-circle back-to-top"><i class="fa fa-arrow-up"></i></a>


        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0/dist/js/bootstrap.bundle.min.js"></script>
        <script src="../../public/lib/wow/wow.min.js"></script>
        <script src="../../public/lib/easing/easing.min.js"></script>
        <script src="../../public/lib/waypoints/waypoints.min.js"></script>
        <script src="../../public/lib/counterup/counterup.min.js"></script>
        <script src="../../public/lib/lightbox/js/lightbox.min.js"></script>
        <script src="../../public/lib/owlcarousel/owl.carousel.min.js"></script>


        <script src="../../public/js/main.js"></script>
        <script src="../index.js" defer></script>

        {/*</body>*/}
        </div>

  );
}

export default StockHome;
